<div class="sera-header-bar">
    <span>{{ text }}</span>
</div>
